"use client"

import React, { useContext } from "react"

import AppContext from "@/ui/components/AppContext"

import type { TJobFilters } from "./JobFilters"

interface BioModalTriggerProps extends React.HTMLAttributes<HTMLButtonElement> {
  modalOpen: boolean
  filters: TJobFilters
}

const JobFiltersModalTrigger: React.FC<BioModalTriggerProps> = ({
  modalOpen,
  filters,
  children,
  ...props
}) => {
  const context = useContext(AppContext)

  return (
    <button
      type="button"
      {...props}
      onClick={() => context.setJobFiltersModal(modalOpen, filters)}
    >
      {children}
    </button>
  )
}

export default JobFiltersModalTrigger
